import React from "react"

export const Bieterkommunikation = ({ size = 1 }) => {
  return (
    <svg
      width={84 * size}
      height={69 * size}
      viewBox="0 0 84 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="#E5EDF0" d="M14.703 7.929h60.98v47.429h-60.98z" />
      <path
        clipRule="evenodd"
        d="M81.613 20.633h-60.98V60.23l40.478.548 20.502 5.38V20.634z"
        stroke="#034055"
        strokeWidth={3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2h60.98v39.597l-40.478.548L2 47.526V2z"
        fill="#FFD62E"
        stroke="#FFD62E"
        strokeWidth={2.964}
      />
      <path
        d="M10.469 13.01h33.877M10.469 21.48h25.408"
        stroke="#034055"
        strokeWidth={3}
      />
    </svg>
  )
}
